module.exports = __webpack_public_path__ + "img/westpex-full-logo.008857b9.png";